import { render, staticRenderFns } from "./AffiliatorForm.vue?vue&type=template&id=f2f8b7f4&"
import script from "./AffiliatorForm.vue?vue&type=script&lang=js&"
export * from "./AffiliatorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports